<template>
  <div class="header sm">
    <div class="header-top">
      <img :src="`${$g.imgPrefix}/img/header/logo@2x.webp`" class="header-logo" @click="goPage('phonehome')"/>
      <div class="header-r">
        <div class="header-user">
          <!-- 未登录显示-->
          <img v-if="isEmpty(userInfo)" :src="defaultImg" @click="goPage('phonelogin')">
          <!-- 已登录显示用户头像-->
          <img v-else :src="userImg" @click="openHeaderDrawer">
        </div>
      </div>
    </div>
    <van-tabs v-model="activeName" @click="setSlideActiveItem">
      <van-tab v-for="(item,i) in tabList" :key="i" :title="item.title" :name="item.name"></van-tab>
    </van-tabs>
    <el-drawer
        custom-class="header-popper"
        title=""
        :visible.sync="showHeadeDrawer"
        :direction="direction"
        :before-close="handleClose">
      <div class="user" @click="goPage('puserinfo');handleClose()">
        <div class="w-100">
          <div class="user-email">{{ userInfo.email }}</div>
          <!-- 个人信息-->
          <div class="user-detail">{{$t('header.personaldetails')}}</div>
        </div>
        <img class="user-arrow" :src="`${$g.imgPrefix}/img/header/arrow-right.svg`">
      </div>
      <div class="content">
        <el-divider class="pl-4 pr-4"></el-divider>
        <div :class="[{'active':slideActiveItem==hItem.activeName},'content-item']"
             v-for="(hItem,hIndex) in headerPopperList"
             :key="hIndex"
             @click="setSlideActiveItem(hItem.activeName)">
          <img :src="hItem.img">
          <div class="content-text">{{ hItem.text }}</div>
        </div>
        <div class="content-item" @click="toSetLang">
          <img :src="`${$g.imgPrefix}/img/header/language.webp`">
          <!-- 选择语言-->
          <div class="content-text">{{$t('footer.language')}}</div>
        </div>
        <el-divider class="pl-4 pr-4"></el-divider>
        <div class="content-item" @click="logOut">
          <img :src="`${$g.imgPrefix}/img/header/logout.webp`">
          <!-- 登出-->
          <div class="content-text">{{$t('userinfo.signout')}}</div>
        </div>
      </div>
    </el-drawer>
    <logOut ref="logOut" v-if="showLogOut" @logOut="refreshPage"></logOut>
    <setLang ref="setLang" @refresh="refreshPage"/>
  </div>
</template>

<script>
import {isEmpty} from "@/util/util"
import logOut from "../logOut";
import setLang from "./setLang";
import PubSub from "pubsub-js";
export default {
  name: "headerTemp",
  inject: ['reload'],
  components: {
    logOut,
    setLang
  },
  data() {
    return {
      //未登录时的默认头像
      defaultImg: `${this.$g.imgPrefix}/img/header/Group1000005849@2x.webp`,
      //已登录的头像 先写死
      userImg: `${this.$g.imgPrefix}/img/home/avatar.svg`,
      activeName: this.$g.phoneActiveTab,
      slideActiveItem: this.$g.phoneActiveTab,
      showHeadeDrawer: false,
      direction: 'btt',
      tabList: [
        {
          //首页
          title: this.$t('map.home'),
          name: 'phonehome'
        },
        {
          //联盟计划
          title: this.$t('map.affiliateprogram'),
          name: 'pfriends'
        },
        {
          //售后支持
          title: this.$t('map.aftersales'),
          name: 'paftersales'
        },
        {
          //订阅
          title: this.$t('map.subscribe'),
          name: 'psubscribe'
        },
        {
          //兑换码
          title: this.$t('excode.redemptioncode'),
          name: 'pexcode'
        },
        {
          //shareAI
          title: 'AI',
          name: 'shareAI'
        }
      ],
      headerPopperList: [
        {
          //我的订阅
          activeName: 'psubscribe',
          img: `${this.$g.imgPrefix}/img/header/subscription.webp`,
          text: this.$t('footer.subscribe')
        },
        {
          //售后支持
          activeName: 'paftersales',
          img: `${this.$g.imgPrefix}/img/header/support.webp`,
          text: this.$t('map.aftersales')
        },
        // {
        //   //帮助中心
        //   activeName: 'phelp',
        //   img: `${this.$g.imgPrefix}/img/header/help.webp`,
        //   text: this.$t('map.helpcenter')
        // },
        {
          //订单
          activeName: 'pOrder',
          img: `${this.$g.imgPrefix}/img/header/history.webp`,
          text: this.$t('map.order')
        },
        {
          //联盟计划
          activeName: 'pfriends',
          img: `${this.$g.imgPrefix}/img/header/affiliate.webp`,
          text: this.$t('map.affiliateprogram')
        }
      ],
      showLogOut: false,
      setTabActiveID: '',
    }
  },
  computed: {
    userInfo() {
      let info = this.$cookies.get("userInfo");
      if (info) {
        info = JSON.parse(this.$cookies.get("userInfo"));
      } else {
        info = ''
      }
      return info;
    }
  },
  methods: {
    isEmpty,
    toSetLang(){
      this.$g.phoneActiveTab = this.activeName;
      this.$nextTick(()=>{
        this.$refs['setLang'].init();
      })
    },
    logOut() {
      this.showLogOut = true;
      this.$nextTick(() => {
        this.$refs['logOut'].init();
      })
    },
    setSlideActiveItem(activeName) {
      this.slideActiveItem = activeName;
      this.activeName = activeName;


      this.handleClose();
      this.goPage(activeName);
    },
    refreshPage() {
      this.handleClose();
      this.reload();
    },
    openHeaderDrawer() {
      this.showHeadeDrawer = true;
    },
    handleClose() {
      this.showHeadeDrawer = false;
    },
    goPage(page) {
      //没有个人信息 去登录
      if(this.isEmpty(this.userInfo)){
        this.$router.push({
          name: 'phonelogin'
        })
        return
      }
      if (page === 'phonehome') {
        this.slideActiveItem = 'phonehome';
        this.activeName = 'phonehome';
      }

      this.$router.push({
        name: page
      })
    },
  },
  mounted() {
    this.setTabActiveID = PubSub.subscribe('setTabActive', (message, activeName) => {
      this.setSlideActiveItem(activeName)
    });
  },
  beforeDestroy() {
    PubSub.unsubscribe(this.setTabActiveID);
  },

}
</script>

<style lang="scss" scoped>
@import "../../assets/css/header.scss";
</style>
<style lang="scss">
.el-drawer.btt.header-popper {
  height: 100% !important;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}

</style>